module.exports = __webpack_public_path__ + "img/vasectomy.8e58e8e0.png";